import { gql } from '@apollo/client';

export const CREATE_SERVICE = gql`
  mutation createService(
    $name: String!
    $price: Float
    $durationInSec: Int!
    $companyId: String!
    $parent: String
  ) {
    createService(
      name: $name
      price: $price
      durationInSec: $durationInSec
      companyId: $companyId
      parent: $parent
    ) {
      name
    }
  }
`;

export const GET_SERVICES = gql`
  query getAllServices($companyId: String!) {
    getAllServices(companyId: $companyId) {
      id
      name
      durationInSec
      price
      Childrens {
        id
        name
        durationInSec
        price
      }
    }
  }
`;
